import { ClientInventory } from "~/components/client";
import PageMeta from "~/components/common/meta";

export function Inventory() {
  return (
    <>
      <PageMeta title={`Inventories | Art Handler`} />
      <ClientInventory />
    </>
  );
}

export default Inventory;
